import VueRouter from 'vue-router';
import Index from '../App.vue';
import pagesVal from './pages.val.js';
import Layout from "../pc/components/Layout";
const routes = [
  {
    path: '/view-pdf',
    name: "ViewPdf",
    component: () => import (/* webpackChunkName: "view_pdf" */ './pages/ViewPdf')
  },
  {
    path: "/",
    component: Layout,
    redirect: { name: 'App' },
    children: [
      {
        path: 'index',
        name: "App",
        component: Index,
        // component: () => import (/* webpackChunkName: "pc_portal" */ '@/pages/pc/portal/index')
      },
      ...pagesVal
    ]
  },
];

const router = new VueRouter({
  routes
});

// router.beforeEach((to, from, next) => {
//   // ...
// })


export default router;
